export type AppConfig = {
  publicUrl: string
  supportEmail: string
  appName: string
  turnstileSiteKey: string
  apiUrl: string
  apiDocsUrl: string
}

const trimSlash = (value: string) => value.replace(/\/+$/, "")

export const getAppConfig = (): AppConfig => ({
  publicUrl: trimSlash(import.meta.env.VITE_PUBLIC_URL || "http://localhost:4738"),
  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL || "fiscalhub@mundoapps.com.br",
  appName: import.meta.env.VITE_APP_NAME || "FiscalHub",
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY || "",
  apiUrl: import.meta.env.DEV
    ? "/api"
    : trimSlash(import.meta.env.VITE_API_URL || "https://fiscalhub.mundoapps.com.br"),
  apiDocsUrl: trimSlash(import.meta.env.VITE_API_DOCS_URL || import.meta.env.VITE_API_URL || "http://127.0.0.1:38418") + "/docs",
})

export const config = getAppConfig()
